import React, { useState } from "react";
import { useHistory } from "react-router";

import { LoginModal } from "../../../components/header";
import { withStyles, Theme } from "@material-ui/core/styles";
import { blue, grey, red } from "@material-ui/core/colors";

import { Button, Box, Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles((theme) => ({
  subtitle: {
    fontFamily: "Roboto, sans-serif",
    fontSize: 15,
    color: "#ffffff",
    fontWeight: 500,
    lineHeight: "26px !important",
    textAlign: "center",
  },
  title: {
    fontFamily: '"Fjalla One", sans-serif',
    fontSize: 40,
    color: "#ffffff",
    marginTop: "32px",
    lineHeight: "50px",
  },
  subtitleBold: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: 22,
    fontWeight: "bold",
    color: "#ffffff",
    lineHeight: "26px !important",
  },
  textContainer: {
    maxWidth: "449px",
    [theme.breakpoints.down("sm")]: {
      margin: "0 20px",
    },
  },
}));
const BlueButton = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.getContrastText(blue[500]),
    "&:hover": {
      backgroundColor: grey[100],
      color: blue[500],
    },
    borderColor: "#ffffff",
    borderWidth: 2,
    borderRadius: 0,
    fontFamily: "Fjalla One",
    fontSize: 16,
    width: 136,
    height: 40,
  },
}))(Button);

const RedButton = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    "&:hover": {
      backgroundColor: grey[100],
      color: red[500],
    },
    borderColor: "#ffffff",
    borderWidth: 2,
    borderRadius: 0,
    fontFamily: "Fjalla One",
    fontSize: 16,
    width: 136,
    height: 40,
  },
}))(Button);

const PartnerDoubtsCards = (props) => {
  const classes = styles();
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const [openModalReg, setOpenModalReg] = useState(false);
  const loginNotRequired = props.loginNotRequired;

  const history = useHistory();

  const handleOpenModalLogin = () => {
    setOpenModalLogin(true);
    setOpenModalReg(false);
  };

  const handleOpenUserInfo = () => {
    history.push("dashboard");
  };

  const handleEscribirnos = () => {
    // history.push('contactanos')
    window.location.assign("/contactanos");
  };

  const handleSwitchModalLogin = () => {
    setOpenModalReg(!openModalReg);
  };

  const handleCloseModalLogin = () => setOpenModalLogin(false);

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
        spacing={4}
        style={{ borderWidth: 1, borderColor: "#000" }}>
        <Grid
          item
          xs={12}
          sm={6}
          style={{ borderWidth: 1, height: "313px", maxWidth: "608px" }}>
          <img
            style={{
              position: "absolute",
              marginTop: 98,
              marginLeft: 10,
              width: "198px",
              height: "172px",
            }}
            /*src="/wcsstore/DpcatalogoB2B/HomePage-V9/socios.png"*/
            src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DpcatalogoB2B/HomePage-V9/socios.png"
            alt=""
          />
          <Box
            display="flex"
            bgcolor="#29aad0"
            justifyContent="center"
            width={"100%"}
            padding={"0 8px"}>
            <Box
              sx={{ height: { xs: 315, sm: 281 } }}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
              justifyContent={"center"}>
              <Box>
                <Typography align="center" className={classes.title}>
                  ¿YA ERES DISTRIBUIDOR?
                </Typography>
              </Box>

              <Box mt={1} className={classes.textContainer}>
                <Typography align="center" className={classes.subtitle}>
                  Si ya eres distribuidor, activa aquí tu cuenta y accede a
                  nuestra plataforma.
                </Typography>
              </Box>

              <Box
                display="flex"
                height={135}
                justifyContent="center"
                alignItems="flex-end">
                <Box mb={4}>
                  {loginNotRequired ? (
                    <BlueButton
                      className={"btn-card-left"}
                      variant="outlined"
                      onClick={handleOpenUserInfo}>
                      MI CUENTA
                    </BlueButton>
                  ) : (
                    <BlueButton
                      variant="outlined"
                      onClick={handleOpenModalLogin}>
                      ACCEDE AQUÍ
                    </BlueButton>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          style={{ borderWidth: 1, height: "340px", maxWidth: "608px" }}>
          <img
            style={{
              position: "absolute",
              marginTop: 100,
              marginLeft: 10,
              width: "198px",
              height: "172px",
            }}
            /*src="/wcsstore/DpcatalogoB2B/HomePage-V9/mensaje.png"*/
            src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DpcatalogoB2B/HomePage-V9/mensaje.png"
            alt=""
          />
          <Box
            display="flex"
            bgcolor="#FD4364"
            justifyContent="center"
            width={"100%"}
            sx={{
              marginTop: { xs: "25px", sm: 0 },
              height: { xs: 315, sm: 281 },
            }}>
            <Box
              height={281}
              maxWidth={576}
              justifyContent="center"
              textAlign="center">
              <Box>
                <Typography align="center" className={classes.title}>
                  ¿TIENES DUDAS?
                </Typography>
              </Box>

              <Box style={{ marginTop: "0px" }}>
                <Typography align="center" className={classes.subtitle}>
                  Te atenderemos en nuestro call center
                </Typography>
                <Typography align="center" className={classes.subtitleBold}>
                  66 99 15 53 00
                </Typography>
                <Typography align="center" className={classes.subtitle}>
                  De Lunes a domingo de 9:00 a 22:00hrs CST
                </Typography>
                <Typography align="center" className={classes.subtitle}>
                  o bien puedes escribirnos
                </Typography>
              </Box>

              <Box
                display="flex"
                height={90}
                justifyContent="center"
                alignItems="flex-end">
                <Box mb={4}>
                  <RedButton
                    variant="outlined"
                    className={"btn-card-right"}
                    onClick={handleEscribirnos}>
                    ESCRIBIRNOS
                  </RedButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <LoginModal
        openModalLogin={openModalLogin}
        handleCloseModalLogin={handleCloseModalLogin}
        openModalReg={openModalReg}
        handleSwitchModalLogin={handleSwitchModalLogin}
      />
    </React.Fragment>
  );
};

export default PartnerDoubtsCards;
